export const getLtsInfoUrl = "/api/v3/mavin/lts";
